<template>
    <div class="mainbody modulewrap">
        <div class="pagemain realwrap">
            <div class="editor" v-html="$common.langinfo(pageinfo.content,pageinfo.content_en)"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {
                pageinfo: {},
            };
        },

        mounted() {

            this.$common.fetch({ 'act': 'tc_terms' }, res => {
                this.pageinfo = res.infodata;
            });
        }
    }
</script>
